import { render } from "./ResultsRing.vue?vue&type=template&id=6442d03c&scoped=true"
import script from "./ResultsRing.vue?vue&type=script&lang=js"
export * from "./ResultsRing.vue?vue&type=script&lang=js"

import "./ResultsRing.vue?vue&type=style&index=0&id=6442d03c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6442d03c"]])

export default __exports__